module.exports = __webpack_public_path__ + "img/header.980d2ad6.png";